import {
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  CLEAR_PROFILE_ERROR
} from '../constants/profileConstants';

export const fetchProfileRequest = (almataId) => ({
  type: FETCH_PROFILE_REQUEST,
  payload: almataId
});

export const fetchProfileSuccess = (data) => ({
  type: FETCH_PROFILE_SUCCESS,
  payload: data
});

export const fetchProfileFailure = (error) => ({
  type: FETCH_PROFILE_FAILURE,
  payload: error
});

export const updateProfileRequest = (profileData) => ({
  type: UPDATE_PROFILE_REQUEST,
  payload: profileData
});

export const updateProfileSuccess = (data) => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: data
});

export const updateProfileFailure = (error) => ({
  type: UPDATE_PROFILE_FAILURE,
  payload: error
});

export const changePasswordRequest = (passwordData) => ({
  type: CHANGE_PASSWORD_REQUEST,
  payload: passwordData
});

export const changePasswordSuccess = (data) => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload: data
});

export const changePasswordFailure = (error) => ({
  type: CHANGE_PASSWORD_FAILURE,
  payload: error
});

export const verifyEmailRequest = (emailData) => ({
  type: VERIFY_EMAIL_REQUEST,
  payload: emailData
});

export const verifyEmailSuccess = (data) => ({
  type: VERIFY_EMAIL_SUCCESS,
  payload: data
});

export const verifyEmailFailure = (error) => ({
  type: VERIFY_EMAIL_FAILURE,
  payload: error
});

export const clearProfileError = () => ({
  type: CLEAR_PROFILE_ERROR
});